import { render, staticRenderFns } from "./Fase8.vue?vue&type=template&id=d1f19240&scoped=true"
import script from "./Fase8.vue?vue&type=script&lang=js"
export * from "./Fase8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f19240",
  null
  
)

export default component.exports